/**
 * Photography lives in the site's CDN storage. Keep every absolute media URL
 * that the code references in this one file so a CDN host change is a one-line edit.
 */
export const CDN_BASE = 'https://local-boost.cdn.modulify.website'

export const MEDIA = {
    shopOwner: {
        src: `${CDN_BASE}/images/photos/shop-owner.webp`,
        width: 2000,
        height: 1333,
        alt: "A smiling local business owner in an apron, arms crossed, standing in the open doorway of his shop",
        focus: { x: 0.555, y: 0.3 }
    },
    previewFront: {
        src: `${CDN_BASE}/images/work/steak-house.jpg`,
        alt: "Full-page website design for a steak house restaurant"
    },
    previewBack: {
        src: `${CDN_BASE}/images/work/interior-design-firm.jpg`,
        alt: "Full-page website design for an interior design firm"
    },
    highFive: {
        src: `${CDN_BASE}/images/photos/high-five.webp`,
        width: 1046,
        height: 1046,
        alt: "Two business partners on a yellow couch sharing a high five over an open laptop"
    }
}
